// extracted by mini-css-extract-plugin
export default {"Btn":"AppButton_Btn__jWz+v","BtnSmall":"AppButton_BtnSmall__HXRYe"};